import { ApiService } from './apiService';
import ErrorService from './errorService';
import api from './api';

export const layoutService = {
    getAllLayout: async () => {
        try {
            const response = ApiService.get('/Layout');
            return response;

        } catch (error) {
            ApiService.handleApiError('Error al obtener layouts:', error);
            throw error;
        }
    },

    getLayoutById: async (id) => {
        try {
            const response = await ApiService.get(`/Layout/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error al obtener layout con id ${id}:`, error);
            throw error;
        }
    },

    getLayoutByServiceId: async (serviceId) => {
        /*
        try {
            const response = await ApiService.get(`/Layout/Service/${serviceId}`);
            return response.data;
        } catch (error) {
            console.error(`Error al obtener el servicio con id ${serviceId}:`, error);
            throw error;
        }*/
       try {
            const response = await ErrorService.withTimeout(api.get(`/Layout/Service/${serviceId}`));
            return response.data;
        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },


    createLayout: async (layoutData) => {
        try {
            const response = await ApiService.post('/Layout', layoutData);
            return response.data;
        } catch (error) {
            console.error('Error al crear layout:', error);
            throw error;
        }
    },

    editLayout: async (id, layoutData) => {
        try {
            layoutData.id = id;
            const response = await ApiService.put(`/Layout/${id}`, layoutData);
            return response.data;
        } catch (error) {
            console.error('Error al editar layout:', error);
            throw error;
        }
    },

    deleteLayout: async (id) => {
        try {
            const response = await ApiService.delete(`/Layout/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error al desactivar:', error);
            throw error;
        }
    },

    //LayoutContratos
    getAllDocumentLayout: async () => {
        try {
            const response = ApiService.get('/Documents');
            return response;

        } catch (error) {
            ApiService.handleApiError('Error al obtener layouts:', error);
            throw error;
        }
    },

    getDocumentLayoutById: async (id) => {
        try {
            const response = await ApiService.get(`/Documents/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error al obtener layout con id ${id}:`, error);
            throw error;
        }
    },

}